import { Injectable } from '@angular/core';
import { LocaleSettings } from '../locale-settings';
import { LocalizationStrategy, mapTransKeyToLocale } from '../localization';
import { PreferencesCookieService } from '@app/core/cookies';

@Injectable()
export class CookieLocalizationService extends LocalizationStrategy {
  constructor(private preferencesCookies: PreferencesCookieService) {
    super();
  }

  localize(): LocaleSettings {
    const ckCookie = this.preferencesCookies.getCkCookie();
    const ccCookie = this.preferencesCookies.getCcCookie();

    if (ckCookie === undefined) {
      return LocaleSettings.DEFAULT;
    }

    return new LocaleSettings(
      mapTransKeyToLocale(ckCookie.languageCode),
      parseInt(ckCookie.regionId, 10),
      ckCookie.currencyCode,
      ccCookie.CC
    );
  }
}
